var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsideCalendarIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55556 0.5V2.9M8.44444 0.5V2.9M0.5 5.3H11.5M1.72222 1.7H10.2778C10.9528 1.7 11.5 2.23726 11.5 2.9V11.3C11.5 11.9627 10.9528 12.5 10.2778 12.5H1.72222C1.04721 12.5 0.5 11.9627 0.5 11.3V2.9C0.5 2.23726 1.04721 1.7 1.72222 1.7Z",
    stroke: "#585858",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsideCalendarIco);
export default __webpack_public_path__ + "static/media/aside--calendar--ico.e367b40d80c13584dfbc2467a921c8e2.svg";
export { ForwardRef as ReactComponent };